export enum EApiKeys {
    ABSOLUTE = "Absolute",
    SHARE = "Share",
}
interface IDomainDataValue {
    Absolute: number;
    Share: number;
}

interface IDomainData {
    Key: string;
    Value: IDomainDataValue;
}

interface IDomain {
    Total: IDomainData[];
    Desktop: IDomainData[];
    Mobile: IDomainData[];
}

export type RawData = {
    [index: string]: IDomain;
};

interface IDomainDataValueV2 {
    Absolute: number;
    Share: number;
}

export interface IDomainDataV2 {
    Key: string;
    Value: IDomainDataValueV2;
}

export interface SwitchGraphTotalMetrics {
    AvgMonthVisits?: number;
    AvgMonthVisitsShare?: number;
}

export interface RegionalDomainData {
    Domain: string;
    AvgMonthVisits?: number;
}

interface SwitchGraphWebSourceData {
    WebSource: string;
    AvgMonthVisits: IDomainDataV2[];
    TotalMetrics: SwitchGraphTotalMetrics;
    RegionalDomains: RegionalDomainData[];
}

export interface SwitchGraphDomainData {
    Id: string;
    Favicon: string;
    Metrics: SwitchGraphWebSourceData[];
    DisplayName?: string;
    Domain?: string;
}

interface SwitchGraphData {
    Data: SwitchGraphDomainData[];
}

export interface SwitchGraphCompareData extends SwitchGraphData {
    CompareData: SwitchGraphDomainData[];
}

export interface IChartData {
    x: number | string;
    y: number;
}

export interface IChart {
    data: IChartData[];
    name: string;
    color: string;
    id: string;
    average?: number;
    zoneAxis?: string;
}

export type ChartData = Array<IChart>;

export type IRawData = {
    Absolute: IChart[];
    Share: IChart[];
};

export enum EChartType {
    AVERAGE,
    OVERTIME,
}

export interface IEnrichedDataMetrics {
    monthlyVisits: number;
    trafficShare: number;
}

interface IEnrichedDataItem extends IEnrichedDataMetrics {
    favicon: string;
    id: string;
    name: string;
    domain: string;
    segmentId: string;
    isSegment?: boolean;
    regionalDomains?: RegionalDomainData[];
}

export type EnrichedData = Record<string, IEnrichedDataItem>;

interface IRecord {
    DesktopMobileShare: Array<number>;
    UniqueUsers: number;
    CategoryRank: number;
    Rank: number;
    Favicon: string;
    CurrMonthVisits: number;
    BounceRate: number;
    PagesPerVisit: number;
    AvgVisitDuration: number;
    LastMonthUniqueUsers: number;
    PrevMonthVisits: number;
    MoMChange: number;
    HasAdsense: boolean;
    Domain: string;
    Type: number;
    Id: string;
    PeriodChange: number;
    Share: number;
    AvgMonthVisits: number;
}

export type Records = Array<IRecord>;

export interface TableRawData {
    Data: Records;
}
